// extracted by mini-css-extract-plugin
export default {"page":"style_page__6cXOt","pageName":"style_pageName__QFpAe","homePage":"style_homePage__+WsOe","pageCont":"style_pageCont__z5Am9"};